import React, { useEffect } from 'react'
import Form from '../../../Common/Form'
import InputButton from '../../../Common/InputButton';

function ProfileView({ editProfile }) {
    useEffect(() => {
        window.document.getElementById('title-page').innerHTML = "ویرایش اطلاعات"
    }, []);
    return (
        <div className='Users'>

            <div className="row justify-content-center">
                <div className="col-md-8 ">
                    <div className='card p-4'>
                        <h5>ویرایش اطلاعات ورود</h5>
                        <Form submit={editProfile} typeData="object">
                            <div className=" card-body row">
                                <div className="form-group my-3 col-lg-12 ">
                                    <label htmlFor="username">نام کاربری</label>
                                    <input type="text" id="username" name='username' className='form-control' />
                                </div>
                                <div className="form-group my-3 col-lg-12 ">
                                    <label htmlFor="password">کلمه عبور</label>
                                    <input type="password" id="password" name='password' className='form-control' />
                                </div>
                                <div className="form-group my-3 col-lg-12 ">
                                    <label htmlFor="new_password">کلمه عبور جدید</label>
                                    <input type="text" id="new_password" name='new_password' className='form-control' />
                                </div>

                                <button className='btn btn-primary col-12 ' type="submit">
                                    <span className="ml-4">ذخیره اطلاعات</span>
                                </button>

                            </div>
                        </Form>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ProfileView